// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"7b401a0204b092cdbb42","339":"671e8308f154108396e3"}[chunkId] + ".js";
};